import React, { HTMLAttributes, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { twMerge } from 'tailwind-merge';

export enum PortalId {
  MESSAGE_PAGE_HEADER_CONTENT = 'message-page-header-content',
}

interface PortalContentProps {
  portalId: PortalId;
  children: ReactNode;
}

/**
 * Utility component for rendering message page content from one subcomponent
 * into another place in the page layout by utilizing React portals
 */
export const PortalContent = ({ portalId, children }: PortalContentProps) => {
  const portalElement = document.getElementById(portalId);

  if (!portalElement) return null;

  return createPortal(children, portalElement);
};

interface PortalNodeProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  id: PortalId;
}

/**
 * Utility component acting as a placeholder for possible portal content rendered in some child component
 */
export const PortalNode = ({ className, ...props }: PortalNodeProps) => (
  <div {...props} className={twMerge('contents w-full', className)} />
);
